import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Redirect } from 'react-router-dom'

import { DomainContext } from '../../domain-repository/DomainRepository'

import withLang from '../../withLang'
import { FooterWithClose } from "../../components/Footer"
import TrackingPage from '../../components/TrackingPage'

import { getQueryStringParams, isSafari, isSafetyExtra } from '../../utils/utils'

export const PACKS_CONFIGS = {
  RF1: { colorClass: 'board-green', discounts: { ACDW1: 30 } },
  RF2: { colorClass: 'board-green', discounts: { ACDW1: 30, ASTOP: 30 } },
  IF1: { colorClass: 'board-green', discounts: { ACDW1: 50 } },
  IF2: { colorClass: 'board-orange', highlight: true, showNoDiscountValue: true, discounts: { ACDW1: 50, ASTOP: 50 } },
  IF3: { colorClass: 'board-silver', discounts: { ACDW1: 50, ASTOP: 50, PAI: 50 } },
}

function SafetyPackDetailedPage({ history, match, location }) {
  const { t } = useTranslation()

  const [activeExtraId, setActiveExtraId] = useState(null)
  const [pack, setPack] = useState(null)

  const {
    appFlowConfigs,
    reservation,
    localizationAssets,
    reservationExtras,
  } = useContext(DomainContext)

  useEffect(() => {
    const safeReservation = reservation || {}

    const packExtraId = match.params.id

    const configuredPacks = (appFlowConfigs.insurancePacks ? appFlowConfigs.insurancePacks.packs : [])
      .filter(p => {
        return safeReservation.availableExtras.find(_ => _.extraID === p.extraId) !== undefined
      })

    const reservationPack = {
      isReservation: true,
      name: t('yourReservation'),
      extrasList: reservationExtras.map(e => e.extraID).filter(isSafetyExtra)
    }

    const _pack = configuredPacks.find(p => p.extraId === packExtraId) || reservationPack
    setPack(_pack)

    const queryStringValues = getQueryStringParams(
      location && location.search ? location.search : null
    )
    const activeExtraIdInUrl = queryStringValues?.active
    const filteredActiveExtraId = activeExtraIdInUrl && _pack.extrasList.includes(activeExtraIdInUrl) ? activeExtraIdInUrl : _pack.extrasList[0]
    setActiveExtraId(filteredActiveExtraId)
  }, [reservation, appFlowConfigs, match?.params?.id])

  return pack ? (
    <div style={{ '--vh': '9.69px' }}>
      <main>
        <div className='container-fluid page-plan'>
          <div className={`main main-full container p-0 ${isSafari()? 'safari' : ''}`}>
            <div className="row">
              <div className="col mt-5">
                <h2 className="text-uppercase">{pack.name}</h2>
                <p>{pack.isReservation ? '' : t(`${pack.extraId}Description`)}</p>
              </div>
            </div>
            <div className="plan-content">
              <div className="items d-flex justify-content-between align-items-center py-3">
                {pack.extrasList.map((extraId, index) => {
                  const isActive = activeExtraId === extraId
                  const whiteIcon = localizationAssets[`safetyPacks${extraId}White`]
                  const orangeIcon = localizationAssets[`safetyPacks${extraId}Orange`]

                  return (
                    <>
                      {index !== 0 ? <span>+</span> : null}
                      <div onClick={() => setActiveExtraId(extraId)} className={`item text-center py-4 px-2 d-flex justify-content-center align-items-center ${isActive ? 'item-active' : ''}`}>
                        <div className="position-relative w-100">
                          {PACKS_CONFIGS[pack.extraId]?.discounts[extraId] ?
                            <div className="stamp">
                              <img src={require(`../../assets/images/stamp-${PACKS_CONFIGS[pack.extraId]?.discounts[extraId]}.svg`)} alt="" />
                            </div>
                            : null}
                          <img style={{ width: '53px', height: '60px' }} src={whiteIcon} alt="" className={`m-auto img-inactive`} />
                          <img style={{ width: '53px', height: '60px' }} src={orangeIcon} alt="" className={`m-auto img-active`} />
                          <p className="lh-1 pt-3 m-0">{t(`${extraId}InsuranceName`, t(`${extraId}Name`))}</p>
                          <img src={require("../../assets/images/ico-info.svg")} alt="" className="position-absolute top-0 end-0 " />
                        </div>
                      </div>
                    </>
                  )
                })}
              </div>
            </div>
            {activeExtraId &&
              <div class="row py-5">
                <div class="col-12">
                  <h2 class="text-uppercase pb-2">{t(`${activeExtraId}InsuranceName`, t(`${activeExtraId}Name`))}</h2>
                  <p>{t(`${activeExtraId}Description`)}</p>
                </div>
                <div class="col-12 video" style={{ display: 'flex' }}>
                  <video style={{ width: '100%', maxWidth: '800px', margin: '0 auto' }} loop muted autoPlay className='img-fluid' src={localizationAssets[`safetyPacks${activeExtraId}Video`]}></video>
                </div>
              </div>
            }
          </div>
        </div>
      </main>
      <FooterWithClose
        handleCloseClick={() => history.replace('/safety-packs')}
      />
    </div>
  ) : null
}

export default withLang(TrackingPage(SafetyPackDetailedPage, 80))
